
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import MobileSearch from './mobile/MobileSearch';
import MobileMenu from './mobile/MobileMenu';

const MobileNav = () => {
  const { user, signOut } = useAuth();
  
  const getUserInitials = () => {
    if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return 'U';
  };
  
  return (
    <div className="flex items-center gap-2">
      <MobileSearch />
      <MobileMenu 
        user={user} 
        signOut={signOut} 
        getUserInitials={getUserInitials} 
      />
    </div>
  );
};

export default MobileNav;
